import { HttpParams } from '@angular/common/http'
import { Component, effect, input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { CellEditEndingEventArgs, Column, DataMap, FlexGrid } from '@grapecity/wijmo.grid'

import { BaseComponent, FeatureType, Grid, ModalSize, NotificationInstance } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'

@Component({
    selector: 'app-sent-notifications',
    templateUrl: './sent-notifications.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
    ],
})
export class SentNotificationsComponent extends BaseComponent {
    faSearch = faSearch
    grid: Grid<NotificationInstance>
    usersGrid: Grid<any>
    usersDataMap!: DataMap
    activeTab = input(1)

    get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.HrNotificationEdit])
    }

    constructor() {
        super()
        this.grid = new Grid<NotificationInstance>(this.services)
            .setupModalEditing(
                this.services.data.notificationInstances,
                'Sent Notification',
                null,
                () => new NotificationInstance(),
                this,
                ModalSize.large,
            )
            .isReadOnly(false)
            .editOnDoubleClick(false)
            .wrapColumnHeaders()
            .filterBy(item => [item.title, item.body])

        this.usersGrid = new Grid<any>(this.services)
            .wrapColumnHeaders()
            .filterBy(item => [item.displayName])
            .isReadOnly(false)

        effect(() => {
            if (this.activeTab() === 2) this.refresh()
        })
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.notificationInstances.queryAll(),
                    this.services.data.groups.queryAll(),
                    this.services.data.users.queryAll(),
                )
                .subscribe({
                    next: result => {
                        this.grid.items = result[0]
                        this.usersDataMap = new DataMap(this.services.data.users.items, 'id', 'displayName')
                    },
                }),
        )
    }

    getRecipients() {
        if (!this.grid.selectedItem) return
        const params = new HttpParams().append('instanceId', this.grid.selectedItem.id)
        this.cancelableRequest(
            'recipients',
            true,
            this.services.data.load(true, true, this.services.data.get('/api/NotificationInstance/GetRecipients', params)).subscribe({
                next: result => {
                    this.usersGrid.items = result[0]
                },
            }),
        )
    }

    backfillRecipients() {
        this.cancelableRequest(
            'backfill',
            true,
            this.services.data.load(true, true, this.services.data.post('/api/Notification/BackfillMissingRecipients', {})).subscribe({
                next: result => {
                    const summary = result[0] as { instancesProcessed: number; recipientsAdded: number }
                    this.services.notification.success(
                        `Added ${summary.recipientsAdded} missing inbox row(s) across ${summary.instancesProcessed} sent notification(s).`,
                    )
                    this.getRecipients()
                },
            }),
        )
    }

    cellEditEnded(flexGrid: FlexGrid, args: CellEditEndingEventArgs) {
        const col = flexGrid.columns[args.col] as Column
        if (args.cancel || col.binding !== 'expiresOn') return

        const item = flexGrid.rows[args.row].dataItem as NotificationInstance
        this.services.data.notificationInstances.edit(item).subscribe({
            error: () => this.services.notification.error('The expiration date was not successfully saved'),
        })
    }

    cellBeginningEdit(flexGrid: FlexGrid, args: CellEditEndingEventArgs) {
        args.cancel = true
    }
}
